// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;The wicked in their pride persecute the poor;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let them be caught in the schemes they have devised.<br> </p> </div></div>";
// Exports
module.exports = code;